import axios from "axios"
import { getUsuario } from "utils/DatosUsuarioLocalStorag"

const getHeadersWithUserContext = () => {
    return {
        'Content-Type': 'application/json',
        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
        'Authorization': `Bearer ${getUsuario()}`,
    };
}

// codigoEvento es opcional: si se pasa, el backend aplica el override de
// configuracion_pagos_evento para ese evento (si existe) en vez del %
// global de cada metodo.
export const ListarMetodosPagoActivos = async (codigoEvento) => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/metodos_pago_activos", {
        headers: getHeadersWithUserContext(),
        params: codigoEvento ? { codigoEvento } : {}
    })
    return data
}

export const ListarComisionesEvento = async (metodo) => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/comisionesEvento/" + metodo, {
        headers: getHeadersWithUserContext()
    })
    return data
}

export const GuardarComisionEvento = async (parms) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/comisionesEvento", parms, {
        headers: getHeadersWithUserContext()
    })
    return data
}

export const EliminarComisionEvento = async (parms) => {
    const { data } = await axios.delete("https://api.t-ickets.com/ms_login/api/v1/comisionesEvento", {
        headers: getHeadersWithUserContext(),
        data: parms
    })
    return data
}

export const ListarConfiguracionPagos = async () => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/configuracion_pagos", {
        headers: getHeadersWithUserContext()
    })
    return data
}

export const ActualizarConfiguracionPago = async (metodo, parms) => {
    const { data } = await axios.put("https://api.t-ickets.com/ms_login/api/v1/configuracion_pagos/" + metodo, parms, {
        headers: getHeadersWithUserContext()
    })
    return data
}

export const ToggleConfiguracionPago = async (metodo, activo) => {
    const { data } = await axios.patch("https://api.t-ickets.com/ms_login/api/v1/configuracion_pagos/" + metodo + "/activo", { activo }, {
        headers: getHeadersWithUserContext()
    })
    return data
}

/* Metodos de pago en los que SI se cobra la comision de la ticketera
 * (comision_boleto) para un evento puntual. [] = sin restriccion (se cobra
 * en todos, comportamiento por defecto). */
export const ListarMetodosComisionBoletoEvento = async (codigoEvento) => {
    const { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/comision_boleto_metodos_evento", {
        headers: getHeadersWithUserContext(),
        params: { codigoEvento }
    })
    return data
}

export const GuardarMetodosComisionBoletoEvento = async (codigoEvento, metodos) => {
    const { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/comision_boleto_metodos_evento", { codigoEvento, metodos }, {
        headers: getHeadersWithUserContext()
    })
    return data
}
